import ScrollSensor from '@immutabl3/scroll-sensor';
import { isClient } from '../utils/index.js';
export default isClient ? ScrollSensor() : null;